export default __webpack_public_path__ + "static/media/Logo_Oakwood_Sign_In.685a7534.svg";